
export type ModalButtonAlignment = number;
export let ModalButtonAlignment: any = {};
ModalButtonAlignment.Right = 0;
ModalButtonAlignment.Left = 1;
ModalButtonAlignment[ModalButtonAlignment.Right] = "Right";
ModalButtonAlignment[ModalButtonAlignment.Left] = "Left";
